/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsScatter: {
  name: 'scatter';
  data: string;
} = {
  name: 'scatter',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 7.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM7.5 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm8.5 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-7 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" fill="currentColor"/></svg>`,
};
